import Link from "next/link";
import Logo from "@/assets/logo.svg";
import InstagramIcon from "@/assets/instagram.svg";
import WhatsAppIcon from "@/assets/whatsapp.svg";

export function Footer() {
  return (
    <footer className="bg-background/95 w-full border-t backdrop-blur-sm">
      <div className="container mx-auto flex flex-col gap-8 px-4 py-10 md:px-6 lg:py-16">
        <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-4">
          <div className="col-span-2 max-w-md space-y-4">
            <Link href="/" className="flex items-center gap-2 font-bold">
              <Logo className="size-6" />
              <span>MEYJE UI</span>
            </Link>
            <p className="text-muted-foreground text-sm">
              Um poderoso editor visual de temas para componentes shadcn/ui com suporte a Tailwind CSS.
              Destaque seus componentes.
            </p>
            <div className="flex gap-4">
              <a
                href="https://wa.me/5561996749762?text=Olá,%20vim%20pelo%20MEYJE%20UI"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                <WhatsAppIcon className="size-5" />
                <span className="sr-only">WhatsApp</span>
              </a>
              <a
                href="https://www.instagram.com/meyje_oficial/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                <InstagramIcon className="size-5" />
                <span className="sr-only">Instagram</span>
              </a>
            </div>
          </div>
          <div className="space-y-4">
            <h4 className="text-sm font-bold">Produto</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  href="/#features"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  Funcionalidades
                </Link>
              </li>
              <li>
                <Link
                  href="/#examples"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  Exemplos
                </Link>
              </li>
            </ul>
          </div>
          <div className="space-y-4">
            <h4 className="text-sm font-bold">Recursos</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="https://wa.me/5561996749762?text=Olá,%20vim%20pelo%20MEYJE%20UI"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                  target="_blank"
                >
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/5561996749762?text=Olá,%20vim%20pelo%20MEYJE%20UI"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                  target="_blank"
                >
                  Contato
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-border/40 flex flex-col items-center justify-between gap-4 border-t pt-8 sm:flex-row">
          <p className="text-muted-foreground text-xs">
            &copy; {new Date().getFullYear()} MEYJE UI. Todos os direitos reservados.
          </p>
          <p className="text-muted-foreground text-xs">
            <Link href="/privacy-policy">Política de Privacidade</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
